/* ==== GENERATED FROM config/custom_size_limits.json — DO NOT EDIT ==== */
var RZ_SIZE_LIMITS = {
  "shapes": {
    "rectangle": {
      "inputs": [
        "width",
        "length"
      ],
      "width_cm": {
        "min": 60,
        "max": 300
      },
      "length_cm": {
        "min": 100,
        "max": 600
      },
      "basis": {
        "width.min": "pool",
        "width.max": "loom",
        "length.min": "pool",
        "length.max": "decision"
      },
      "capability": "established",
      "note": "The shape the pool is built from. 257 of its 335 sizes are rectangles."
    },
    "runner": {
      "inputs": [
        "width",
        "length"
      ],
      "width_cm": {
        "min": 60,
        "max": 120
      },
      "length_cm": {
        "min": 150,
        "max": 600
      },
      "min_ratio": 2.5,
      "basis": {
        "width.min": "pool",
        "width.max": "pool",
        "length.min": "pool",
        "length.max": "decision",
        "min_ratio": "pool"
      },
      "capability": "established",
      "note": "A runner is NARROW AND LONG, and both halves are the pool's own rule \u2014 build_sizes.RUNNER_WIDTHS caps the width at 120 cm and RUNNER_MIN_RATIO requires length/width >= 2.5. 150 cm is the shortest length that can satisfy the ratio at the 60 cm floor."
    },
    "square": {
      "inputs": [
        "side"
      ],
      "width_cm": {
        "min": 80,
        "max": 300
      },
      "length_cm": {
        "min": 80,
        "max": 300
      },
      "basis": {
        "width.min": "precedent",
        "width.max": "loom",
        "length.min": "precedent",
        "length.max": "loom"
      },
      "capability": "inferred",
      "note": "ONE NUMBER. A square's side is both its width and its length, so the loom bounds it twice. The floor is the smallest square we sell (80 cm, Crea's). CAPABILITY IS INFERRED, NOT READ: every square in the catalogue is a manufacturer's, we have never produced one of our own, and the only thing pointing the other way is that a round of the same size is printed on the same square panel. Flagged so it can be overruled."
    },
    "round": {
      "inputs": [
        "diameter"
      ],
      "width_cm": {
        "min": 80,
        "max": 300
      },
      "length_cm": {
        "min": 80,
        "max": 300
      },
      "basis": {
        "width.min": "precedent",
        "width.max": "loom",
        "length.min": "precedent",
        "length.max": "loom"
      },
      "capability": "established",
      "note": "ONE NUMBER, the diameter \u2014 a circle has no width and length, and asking for two states a measurement the rug does not have. The ceiling is the loom and the largest round we sell, which agree at 300 cm; the floor is the smallest we sell."
    },
    "oval": {
      "inputs": [
        "width",
        "length"
      ],
      "width_cm": {
        "min": 80,
        "max": 300
      },
      "length_cm": {
        "min": 120,
        "max": 600
      },
      "basis": {
        "width.min": "precedent",
        "width.max": "loom",
        "length.min": "precedent",
        "length.max": "decision"
      },
      "capability": "established",
      "note": "Width and length, like a rectangle \u2014 an ellipse has both. The floors are the smallest oval we sell (80x120). The largest we sell is 260x370; the envelope goes further because the bound above it is the loom and the length decision, exactly as for a rectangle."
    }
  }
};

function rzInputs(shape) { return (RZ_SIZE_LIMITS.shapes[shape] || {}).inputs || []; }
function rzIsSingle(shape) { return rzInputs(shape).length === 1; }
function rzShapes() { return Object.keys(RZ_SIZE_LIMITS.shapes); }
function rzFtIn(t) { return Math.floor(t / 12) + "'" + (t % 12) + '"'; }
function rzInchMin(cm) { return rzFtIn(Math.ceil(cm / 2.54 - 1e-9)); }
function rzInchMax(cm) { return rzFtIn(Math.floor(cm / 2.54 + 1e-9)); }
function rzRange(shape, field) {
  var b = RZ_SIZE_LIMITS.shapes[shape][field + '_cm'];
  return b.min + '\u2013' + b.max + ' cm (' + rzInchMin(b.min) + '\u2013' + rzInchMax(b.max) + ')';
}
function rzNormalise(shape, a, b) {
  if (a === null || a === undefined || !isFinite(a)) return null;
  if (rzIsSingle(shape)) {
    if (b === null || b === undefined || !isFinite(b) || Math.round(b) === Math.round(a))
      return [Math.round(a), Math.round(a)];
    return [Math.round(b), Math.round(a)];
  }
  if (b === null || b === undefined || !isFinite(b)) return null;
  var w = Math.round(a), l = Math.round(b);
  return w <= l ? [w, l] : [l, w];
}
function rzWhy(shape, field, over) {
  var basis = RZ_SIZE_LIMITS.shapes[shape].basis[field + '.' + (over ? 'max' : 'min')];
  if (!over) return 'smaller than we make';
  if (basis === 'loom') return 'wider than our loom can weave';
  if (basis === 'decision') return 'longer than we make';
  if (basis === 'pool') return field === 'width' ? 'wider than we make' : 'longer than we make';
  if (basis === 'precedent') return 'larger than we make';
  return 'outside what we make';
}
function rzAndList(x) {
  return x.length > 1 ? x.slice(0, -1).join(', ') + ' and ' + x[x.length - 1] : x[0];
}
function rzCap(s) { return s.charAt(0).toUpperCase() + s.slice(1); }
function rzValidate(shape, a, b) {
  shape = String(shape || '').trim().toLowerCase();
  if (!RZ_SIZE_LIMITS.shapes[shape])
    return 'Choose a shape first \u2014 we make ' + rzAndList(rzShapes().map(rzCap)) + '.';
  var single = rzIsSingle(shape), spec = RZ_SIZE_LIMITS.shapes[shape];
  var hasA = a !== null && a !== undefined && a !== '';
  var hasB = b !== null && b !== undefined && b !== '';
  if (!hasA || (!single && !hasB)) return null;
  a = Number(a); b = hasB ? Number(b) : null;
  if (!isFinite(a) || (b !== null && !isFinite(b))) return 'Please enter the size in numbers.';
  if (a <= 0 || (b !== null && b <= 0)) return 'The size must be greater than zero.';
  var one = rzInputs(shape)[0];
  if (single && b !== null && Math.round(b) !== Math.round(a))
    return 'A ' + shape + ' rug is one measurement \u2014 its ' + one + '. '
         + rzCap(shape) + 's are ' + rzRange(shape, 'width') + ' '
         + (shape === 'round' ? 'across' : 'on each side') + '.';
  var n = rzNormalise(shape, a, b);
  if (!n) return null;
  var w = n[0], l = n[1];
  if (single) {
    var lo = spec.width_cm.min, hi = spec.width_cm.max;
    if (w < lo || w > hi)
      return rzCap(shape) + ' rugs are ' + rzRange(shape, 'width') + ' '
           + (shape === 'round' ? 'across' : 'on each side') + '. ' + w + ' cm ('
           + (w > hi ? rzInchMax(w) : rzInchMin(w)) + ') is ' + rzWhy(shape, 'width', w > hi) + '.';
    return null;
  }
  var fields = [['width', w], ['length', l]];
  for (var i = 0; i < fields.length; i++) {
    var f = fields[i][0], v = fields[i][1];
    var flo = spec[f + '_cm'].min, fhi = spec[f + '_cm'].max;
    if (v < flo || v > fhi)
      return rzCap(f) + ' must be ' + rzRange(shape, f) + '. ' + v + ' cm ('
           + (v > fhi ? rzInchMax(v) : rzInchMin(v)) + ') is ' + rzWhy(shape, f, v > fhi) + '.';
  }
  var ratio = spec.min_ratio;
  if (ratio && l / w < ratio) {
    var needL = Math.ceil(w * ratio), maxW = Math.floor(l / ratio);
    var msg = 'A runner is at least ' + ratio + ' times as long as it is wide. At '
            + w + ' cm wide the shortest runner is ' + needL + ' cm (' + rzInchMin(needL) + ').';
    if (maxW > spec.width_cm.min)
      msg += ' For a ' + l + ' cm length the widest is ' + maxW + ' cm (' + rzInchMax(maxW) + ').';
    return msg;
  }
  return null;
}
/* ==== END GENERATED ==== */
